import { Box, Paper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { CardHeader } from "./CardHeader"
import classes from "../real.module.css"

interface Props {
  deliveryRate: number
  avgDeliveryDays: number | null
}

export function DeliveryPerformanceCard({ deliveryRate, avgDeliveryDays }: Props) {
  const { t } = useTranslation(["dashboard"])

  return (
    <Paper className={classes.card}>
      <CardHeader
        title={t("dashboard:widgets.deliveryPerformance")}
        subtitle={`${t("dashboard:widgets.deliveryPerformanceSub", { defaultValue: "Энэ сарын үзүүлэлт" })} · ${t("dashboard:selectedMonth")}`}
      />

      <Box>
        <Text className={classes.fulfillmentLabel}>{t("dashboard:widgets.completionRate")}</Text>
        <Text className={classes.fulfillmentValue}>
          {deliveryRate}
          <Text component="span" className={classes.fulfillmentUnit}>%</Text>
        </Text>
        <Box className={classes.fulfillmentBar}>
          <Box className={classes.fulfillmentBarFill} style={{ width: `${deliveryRate}%` }} />
        </Box>
      </Box>

      <Box className={classes.fulfillmentDivider}>
        <Text className={classes.fulfillmentLabel}>{t("dashboard:widgets.avgDeliveryTime")}</Text>
        <Text className={classes.fulfillmentValue}>
          {avgDeliveryDays !== null ? (
            <>
              {avgDeliveryDays}
              <Text component="span" className={classes.fulfillmentUnit}>
                {" "}{t("dashboard:numberFormat.days")}
              </Text>
            </>
          ) : (
            t("dashboard:numberFormat.daysAlt")
          )}
        </Text>
      </Box>
    </Paper>
  )
}
